export const version = "logger/5.4.1";
//# sourceMappingURL=_version.js.map